import { render, staticRenderFns } from "./UserAdminManageUserPermissions.vue?vue&type=template&id=2a775d8e&scoped=true"
import script from "./UserAdminManageUserPermissions.vue?vue&type=script&lang=js"
export * from "./UserAdminManageUserPermissions.vue?vue&type=script&lang=js"
import style0 from "./UserAdminManageUserPermissions.vue?vue&type=style&index=0&id=2a775d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a775d8e",
  null
  
)

export default component.exports